import { useBreakpoint } from '../../../../hooks';
import { variantProps } from '../../types';
import { PAGE_BREAKPOINTS } from '../../../../constants/commonConstants';
import { Conditional } from '../../../common';
import { EquipmentName, EquipmentNameTooltip } from '../../my-equipment-list';

type EquipmentLabelProps = {
  label: string;
  variant?: variantProps;
  searchTerm: string;
  isVirtualScroll?: boolean;
};

export const EquipmentLabel = ({
  label,
  variant = 'display-sm',
  searchTerm,
  isVirtualScroll = false
}: EquipmentLabelProps) => {
  const isLG = useBreakpoint(PAGE_BREAKPOINTS.BLOCKS_LG);
  return (
    <Conditional
      test={!!isLG}
      fallback={
        <EquipmentName
          variant={variant}
          text={label}
          textToHighlightTerm={searchTerm}
          isVirtualScroll={isVirtualScroll}
        />
      }
    >
      <EquipmentNameTooltip toolTipContent={label}>
        <EquipmentName
          variant={variant}
          text={label}
          textToHighlightTerm={searchTerm}
          isVirtualScroll={isVirtualScroll}
        />
      </EquipmentNameTooltip>
    </Conditional>
  );
};
